/**
 * WIL-207 — vehicle-data adapter.
 *
 * Reads the converted 3-tier catalog today; consumers must only call this
 * surface so the source can swap to fitment.* metafields later.
 */
(function () {
  /** @typedef {{ makes: Record<string, string[]>, modelYears: Record<string, string[]>, seriesYears: Record<string, string[]> }} VehicleCatalog */

  /** @type {Promise<VehicleCatalog> | null} */
  let pending = null;
  /** @type {VehicleCatalog | null} */
  let catalog = null;

  function catalogUrl() {
    const host = document.querySelector('[data-vehicle-catalog-url]');
    if (host instanceof HTMLElement && host.dataset.vehicleCatalogUrl) {
      return host.dataset.vehicleCatalogUrl;
    }
    return '';
  }

  /** @returns {Promise<VehicleCatalog>} */
  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    if (pending) return pending;

    const url = catalogUrl();
    if (!url) {
      return Promise.reject(new Error('vehicle catalog URL missing'));
    }

    pending = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`vehicle catalog ${response.status}`);
        return response.json();
      })
      .then((data) => {
        catalog = {
          makes: data.makes || {},
          modelYears: data.modelYears || {},
          seriesYears: data.seriesYears || {},
        };
        pending = null;
        return catalog;
      })
      .catch((error) => {
        pending = null;
        throw error;
      });

    return pending;
  }

  /** @param {VehicleCatalog} data */
  function getMakes(data) {
    return Object.keys(data.makes);
  }

  /**
   * @param {VehicleCatalog} data
   * @param {string} make
   */
  function getModels(data, make) {
    return data.makes[make] ? data.makes[make].slice() : [];
  }

  /**
   * Legacy keys years by model name only (Ford Ranger and Hino Ranger share a row).
   * @param {VehicleCatalog} data
   * @param {string} _make
   * @param {string} model
   */
  function getYears(data, _make, model) {
    return data.modelYears[model] ? data.modelYears[model].slice() : [];
  }

  /**
   * @param {VehicleCatalog} data
   * @param {string} _make
   * @param {string} model
   * @param {string} year
   */
  function getSeries(data, _make, model, year) {
    const key = `${model}_${year}`;
    return data.seriesYears[key] ? data.seriesYears[key].slice() : [];
  }

  /**
   * Contract §2 URL — single source in map-utils.js (WIL-461).
   * @param {Record<string, string | undefined>} vehicle
   */
  function vehicleShopUrl(vehicle) {
    return window.MapUtils.vehicleShopUrl(vehicle);
  }

  window.MAPVehicleData = {
    loadCatalog,
    getMakes,
    getModels,
    getYears,
    getSeries,
    vehicleShopUrl,
  };
})();
